// PROJECT LIST TEMPLATE
export function renderProjectTemp (data) {
    let image = '';

    if (data.image) {
        image = `
            <div class="c-pp-tile__image">
                <picture>
                    <!--[if IE 9]><video style="display: none;><![endif]-->
                        <source data-srcset="${data.image.url.desktop}" media="--desktop">
                        <source data-srcset="${data.image.url.tablet}" media="--tablet">
                        <source data-srcset="${data.image.url.mobile}" media="--mobile">
                    <!--[if IE 9]></video><![endif]-->
                    <img src="" alt="${data.image.alt}" class="o-image o-image--fit js-lazy-load">
                    <span class="o-image__preloader"></span>
                </picture>
                ${data.category ? `<h4 class="c-pp-tile__category">${data.category}</h4>` : ''}
            </div><!-- /.c-pp-tile__image -->
        `;
    }

    let template = `
        <article class="c-pp-tile">
            <div class="c-pp-tile__block">
                <a href="${data.ctalink}" class="c-pp-tile__link [ u-link-block ]" title="${data.city}"></a>
                ${image}
                <div class="c-pp-tile__content">
                    ${data.city ? `<h4 class="c-pp-tile__title">${data.city}</h4>` : ''}
                    ${data.title ? `<p class="c-pp-tile__description">${data.title}</p>` : ''}
                </div><!-- /.c-pp-tile__content -->
            </div><!-- /.c-pp-tile__block -->
        </article>
    `;

    return template;
}


// KNOWLEDGE LIBRARY TEMPLATE
export function renderKLTemp (data) {
    let media = '';

    if (data.image) {
        media = `
            <picture>
                <!--[if IE 9]><video style="display: none;><![endif]-->
                    <source data-srcset="${data.image.url.desktop}" media="--desktop">
                    <source data-srcset="${data.image.url.tablet}" media="--tablet">
                    <source data-srcset="${data.image.url.mobile}" media="--mobile">
                <!--[if IE 9]></video><![endif]-->

                <img src="" alt="${data.image.alt}" class="o-image o-image--fit js-lazy-load">
                <span class="o-image__preloader"></span>
            </picture>
        `;
    } else {
        media = `
            <div class="c-cp-tile__placeholder" data-color="${data.FormatIcon.color}">
                <div class="c-cp-tile__placeholder__image">
                    <picture>
                        <!--[if IE 9]><video style="display: none;><![endif]-->
                            <source data-srcset="${data.FormatIcon.image.url.desktop}" media="--desktop">
                            <source data-srcset="${data.FormatIcon.image.url.tablet}" media="--tablet">
                            <source data-srcset="${data.FormatIcon.image.url.mobile}" media="--mobile">
                        <!--[if IE 9]></video><![endif]-->

                        <img src="" alt="${data.FormatIcon.image.alt}" class="o-image o-image--fit js-lazy-load">
                        <span class="o-image__preloader"></span>
                    </picture>
                </div><!-- /.c-cp-tile__placeholder__image -->
            </div><!-- /.c-cp-tile__placeholder -->
        `;
    }

    let template = `
        <article class="c-cp-tile">
            <div class="c-cp-tile__block">
                <h4 class="c-cp-tile__category">${data.category}</h4>
                <div class="c-cp-tile__content">
                    <div class="c-cp-tile__content__box">
                        <h3 class="c-cp-tile__title"><a href="${data.ctalink}" title="${data.heroTitle}">${data.heroTitle}</a></h3>
                        ${data.teaser_text ? `<p class="c-cp-tile__description">${data.teaser_text}</p>` : ''}
                        <span class="c-cp-tile__fs">
                            ${data.format ? `<span class="o-cta">${data.format}</span>` : ''}
                            ${data.source ? `<span class="o-source">${data.source}</span>` : ''}
                        </span>
                    </div>
                </div>
                <div class="c-cp-tile__image">
                    <a href="${data.ctalink}" class="[ u-link-block ]" title="${data.heroTitle}"></a>
                    ${media}
                </div><!-- /.c-cp-tile__image -->
            </div><!-- /.c-cp-tile__block -->
        </article>
    `;

    return template;
}


// NEWS AND EVENTS TEMPLATE
export function renderNewsTemp (data) {
    let image = '';

    if (data.image) {
        image = `
            <div class="o-article-item__image">
                <div class="o-article-item__image__container">
                <picture>
                    <!--[if IE 9]><video style="display: none;><![endif]-->
                        <source data-srcset="${data.image.url.desktop}" media="--desktop">
                        <source data-srcset="${data.image.url.tablet}" media="--tablet">
                        <source data-srcset="${data.image.url.mobile}" media="--mobile">
                    <!--[if IE 9]></video><![endif]-->
                    <img src="" alt="${data.image.alt}" class="o-image o-image--fit js-lazy-load">
                    <span class="o-image__preloader"></span>
                </picture>
                </div>
                ${data.format || data.source ? `
                    <span class="o-article-item__meta">
                        ${data.format ? `<span class="o-article-item__type">${data.format}</span>` : ''}
                        ${data.source ? `<span class="o-article-item__source">${data.source}</span>` : ''}
                    </span>
                ` : ''}
            </div><!-- /.o-article-item__image -->
        `;
    }

    let template = `
        <article class="o-article-item">
            ${image}
            <div class="o-article-item__content">
                <h4 class="o-article-item__format">${data.category}</h4>
                <div class="o-article-item__details">
                    ${data.teaser_text ? `<p class="o-article-item__description">${data.teaser_text}</p>` : ''}
                    <h3 class="o-article-item__title"><a href="${data.ctalink}" title="${data.title}">${data.title}</a></h3>

                    ${data.format || data.source ? `
                        <span class="o-article-item__meta">
                            ${data.format ? `<span class="o-article-item__type">${data.format}</span>` : ''}
                            ${data.source ? `<span class="o-article-item__source">${data.source}</span>` : ''}
                        </span>
                    ` : ''}
                </div><!-- /.o-article-item__details -->
            </div><!-- /.o-article-item__content -->
        </article><!-- /.o-article-item -->
    `;

    return template;
}


// SEARCH ARTICLE ITEM TEMPLATE
export function renderArticleItemTemp (data, isKnowledgeSearch = false) {
    let image = '';

    if (data.image) {
        image = `
            <div class="o-article-item__image">
                <div class="o-article-item__image__container">
                    <picture>
                        <!--[if IE 9]><video style="display: none;><![endif]-->
                            <source data-srcset="${data.image.url.desktop}" media="--desktop">
                            <source data-srcset="${data.image.url.tablet}" media="--tablet">
                            <source data-srcset="${data.image.url.mobile}" media="--mobile">
                        <!--[if IE 9]></video><![endif]-->
                        <img src="" alt="${data.image.alt}" class="o-image o-image--fit js-lazy-load">
                        <span class="o-image__preloader"></span>
                    </picture>
                </div>
                ${data.metaType || data.metaSource ? `
                    <span class="o-article-item__meta">
                        ${data.metaType ? `<span class="o-article-item__type">${data.metaType}</span>` : ''}
                        ${data.metaSource ? `<span class="o-article-item__source">${data.metaSource}</span>` : ''}
                    </span>
                ` : ''}
            </div><!-- /.o-article-item__image -->
        `;
    }

    if (!data.image && isKnowledgeSearch) {
        image = `
            <div class="o-article-item__image placeholder">
                <div class="o-article-item__image__container" data-color="${data.formatColor}">
                    <picture>
                        <source data-srcset="//cff-prod.s3.amazonaws.com/storage/images/desktop/a6dc26eb91c72ff3e642b05406c7f0b2.png" media="(min-width: 1440px)" srcset="//cff-prod.s3.amazonaws.com/storage/images/desktop/a6dc26eb91c72ff3e642b05406c7f0b2.png">
                        <source data-srcset="//cff-prod.s3.amazonaws.com/storage/images/tablet/a6dc26eb91c72ff3e642b05406c7f0b2.png" media="(min-width: 750px) and (max-width: 1439px)" srcset="//cff-prod.s3.amazonaws.com/storage/images/tablet/a6dc26eb91c72ff3e642b05406c7f0b2.png">
                        <source data-srcset="//cff-prod.s3.amazonaws.com/storage/images/mobile/a6dc26eb91c72ff3e642b05406c7f0b2.png" media="(min-width: 0) and (max-width: 749px)" srcset="//cff-prod.s3.amazonaws.com/storage/images/mobile/a6dc26eb91c72ff3e642b05406c7f0b2.png">
                        <img src="" alt="resource-document.png" class="o-image o-image--fit o-image--loaded">
                        <span class="o-image__preloader" style=""></span>
                    </picture>
                </div>
            </div>
        `;
    }

    let template = `
        <article class="o-article-item">
            ${image}
            <div class="o-article-item__content">
                <h4 class="o-article-item__format">${data.metaKicker}</h4>
                <div class="o-article-item__details">
                    ${data.teaser_text ? `<p class="o-article-item__description">${data.teaser_text}</p>` : ''}
                    <h3 class="o-article-item__title"><a href="${data.ctalink}">${data.title}</a></h3>
                    ${data.metaType || data.metaSource ? `
                        <span class="o-article-item__meta">
                            ${data.metaType ? `<span class="o-article-item__type">${data.metaType}</span>` : ''}
                            ${data.metaSource ? `<span class="o-article-item__source">${data.metaSource}</span>` : ''}
                        </span>
                    ` : ''}
                </div><!-- /.o-article-item__details -->
            </div><!-- /.o-article-item__content -->
        </article>
    `;

    return template;
}


// NO RESULTS TEMPLATE
export function noResultsTemp (heading = String, sub = String) {
    let template = `
        <div class="c-no-results [ u-tac ]">
            <h4 class="c-no-results__heading">${heading}</h4>
            ${sub ? `<h6 class="c-no-results__sub-heading">${sub}</h6>` : ''}
        </div>
    `;

    return template;
}
